import React from "react";
import { CSSTransition } from "react-transition-group";

type LoadingIndicatorProps = {
  loading: boolean;
};

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ loading }) => (
  <CSSTransition in={loading} timeout={500} classNames="fade" unmountOnExit>
    <div className="loading-indicator">
      <div></div>
    </div>
  </CSSTransition>
);

export default LoadingIndicator;
